import Vue from 'vue';

import { SET, UNSET, SET_BALANCE, SET_PASSWORDS, UPDATE_STATE, SET_WINNING_JACKPOT, SHOW_WON_JACKPOT, SET_SKIP_UPDATES } from './mutation-types';

export default {
    [SET](state, player) {
        state.player = player;
        var hasMainMenu = false;
        if (player && player.branchParameters && player.branchParameters.kiosk) {
            var kioskParams = JSON.parse(player.branchParameters.kiosk);
            hasMainMenu = kioskParams && kioskParams.lobby && kioskParams.lobby.enabled;
            player.hasMainMenu = hasMainMenu;
        }
    },
    [UNSET](state) {
        state.player = null;
    },
    [SET_BALANCE](state, balance) {
        state.player.balance = balance;
    },
    [SET_PASSWORDS](state, params) {
        state.player.branchParameters.internetPassword = params.internetPassword;
        state.player.branchParameters.gamesPassword = params.gamesPassword;
    },
    [UPDATE_STATE](state, playerState) {
        Vue.set(state.player, 'haveWithdrawPins', playerState.haveWithdrawPins);
        Vue.set(state.player, 'balancesCount', playerState.balancesCount);
        Vue.set(state.player, 'activeJackpots', playerState.activeJackpots);
        Vue.set(state.player, 'activeSessions', playerState.activeSessions);
        Vue.set(state.player, 'winningJackpot', playerState.winningJackpot);
        Vue.set(state.player, 'lastWonJackpot', playerState.lastWonJackpot);
        Vue.set(state.player, 'lastAccess', playerState.lastAccess);
        Vue.set(state.player, 'lastAccessPeriodMs', playerState.lastAccessPeriodMs);
        Vue.set(state.player, 'nextBonusPinActivationTime', playerState.nextBonusPinActivationTime);
        Vue.set(state.player, 'notReadMessages', playerState.notReadMessages);
        Vue.set(state.player, 'bonuses', playerState.bonuses);
        Vue.set(state.player, 'jackpots', playerState.jackpots);
    },
    [SET_WINNING_JACKPOT](state, winningJackpot) {
        Vue.set(state.player, 'winningJackpot', winningJackpot);
    },
    [SHOW_WON_JACKPOT](state, wonJackpot) {
        if (!state.player.wonJackpotsShown) state.player.wonJackpotsShown = [];

        state.player.wonJackpotsShown.push(wonJackpot.number);
    }
};



// WEBPACK FOOTER //
// ./_common/data/player/mutations.js